import { Trans } from '@lingui/react'

import { useSubmitAdditionalInfoIntroMutation } from '@twisto/api-graphql'
import { FlowFormSubmitInfoView } from '@twisto/flow-views/components'
import { BigTwistoIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'
import { PromoCode } from '../additional-info-intro-step/promo-code'

export const AdditionalInfoIntroStep = () => {
  const { sessionId } = useFlow<'AdditionalInfoIntroStep'>()
  const [submitAdditionalInfoIntroMutation] =
    useSubmitAdditionalInfoIntroMutation({
      variables: {
        auth: { sessionId },
      },
    })

  return (
    <>
      <FlowFormSubmitInfoView
        buttonText={<Trans id="flow.additionalInfoIntroStep.submit" />}
        icon={<BigTwistoIcon color="primary" height="100%" width="100%" />}
        subtitle={
          <Trans
            components={[<br key={0} />]}
            id="flow.additionalInfoIntroStep.subtitle"
          />
        }
        title={<Trans id="flow.additionalInfoIntroStep.title" />}
        onSubmit={submitAdditionalInfoIntroMutation}
      />
      <PromoCode />
    </>
  )
}
